import axios from 'axios';
import API from "../config/API";

export const marketingService = {
    createMarketingSetting,
    getMarketingSetting,
    getSettings,
    updateSetting,
    addReminder,
    removeReminder,
    updateMarketingSetting,
    uploadReminderImage,
    uploadEmailBodyImage,
    deleteEmailBodyImage,
    // Campaign services
    createCampaign,
    updateCampaign,
    sendCampaign,
    getCampaigns,
    getCampaignDetails,
    getCampaignRecipients,
    deleteCampaign,
    estimateCost,
    getAudienceSegments,
    // Analytics services
    getAnalyticsOverview,
    getAutomationStats,
    getClientCommunications,
    getEmailTemplatePreview,
    getInsights,
    exportAnalytics,
    // Content services
    getSalonReviews,
    // Client-side marketing preferences
    getMyMarketingPreferences,
    setMyMarketingPreference,
    // SMS wallet
    smsWalletTopup,
    smsWalletConfirm,
    smsWalletAutoRecharge,
    smsWalletPurchases,
    smsWalletCheckout,
    smsWalletLocations,
    smsWalletSetSeparate
};

function _authHeaders() {
    return {
        'Content-Type': 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${localStorage.getItem('accessToken')}`
    };
}
// ---- Client-side marketing preferences (the signed-in client's own) ----
function getMyMarketingPreferences() {
    return axios.get(API.MY_MARKETING_PREFERENCES, { headers: _authHeaders() });
}
// ownerUserId omitted/null targets the salon-wide stop.
function setMyMarketingPreference(params) {
    return axios.post(API.MY_MARKETING_PREFERENCES, params, { headers: _authHeaders() });
}

// Buy marketing SMS credits (£amount) on the saved card.
function smsWalletTopup(amount) {
    return axios.post(API.SMS_WALLET_TOPUP, { amount }, { headers: _authHeaders() });
}
// Finalise a top-up after an on-session SCA confirm.
function smsWalletConfirm(params) {
    return axios.post(API.SMS_WALLET_CONFIRM, params, { headers: _authHeaders() });
}
// Configure auto-recharge { enabled, thresholdSms, topupAmountGBP }.
function smsWalletAutoRecharge(params) {
    return axios.put(API.SMS_WALLET_AUTORECHARGE, params, { headers: _authHeaders() });
}
// Hosted-checkout top-up — returns a Stripe URL to redirect to. Used when there's
// no card on file, when the saved card needs SCA, or when the owner wants to pay
// on a different card.
function smsWalletCheckout(amount) {
    return axios.post(API.SMS_WALLET_CHECKOUT, { amount }, { headers: _authHeaders() });
}
// Multi-location: the shared credit balance, which locations share it, each
// location's free allowance and its "Separate marketing credits" switch.
function smsWalletLocations() {
    return axios.get(API.SMS_WALLET_LOCATIONS, { headers: _authHeaders() });
}
// locationId, not salonId: the location being switched is often not the active one.
function smsWalletSetSeparate(locationId, separate) {
    return axios.put(API.SMS_WALLET_SEPARATE, { locationId, separate: !!separate }, { headers: _authHeaders() });
}
// Credit purchase history for the billing page (owner-only, own salon).
function smsWalletPurchases(params) {
    return axios.get(API.SMS_WALLET_PURCHASES, { params, headers: _authHeaders() });
}

  function getSettings() {
    let accessToken = localStorage.getItem('accessToken');
    let headers = {
      'Content-Type': 'application/json',
      'authorization': "Basic YmV1YXBwOmJldWFwcA==",
      'accessToken': `${accessToken}`
    };

      return axios.get(API.GET_MARKETING_SETTING, {
        headers: headers });
  
  }
  

function createMarketingSetting(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    // console.log("headers",headers, params);
    return axios.post(API.CREATE_MARKETING_SETTING, params,{headers:headers})
}

function updateSetting(params) {
    let accessToken = localStorage.getItem('accessToken');
    let  headers= {
        'Content-Type' : 'application/json',
        'authorization': "Basic YmV1YXBwOmJldWFwcA==",
        'accessToken': `${accessToken}`
    };
    // console.log("headers",headers, params);
    return axios.put(API.UPDATE_SETTING, params,{headers:headers})
}

function removeReminder(params) {
  let accessToken = localStorage.getItem('accessToken');
  let  headers= {
      'Content-Type' : 'application/json',
      'authorization': "Basic YmV1YXBwOmJldWFwcA==",
      'accessToken': `${accessToken}`
  };
  // console.log("headers",headers, params);
  return axios.put(API.REMOVE_REMINDER, params,{headers:headers})
}

function addReminder(params) {
  let accessToken = localStorage.getItem('accessToken');
  let  headers= {
      'Content-Type' : 'application/json',
      'authorization': "Basic YmV1YXBwOmJldWFwcA==",
      'accessToken': `${accessToken}`
  };
  // console.log("headers",headers, params);
  return axios.put(API.CREATE_REMINDER, params,{headers:headers})
}


function getMarketingSetting() {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
    return axios.get(API.GET_MARKETING_SALON_SETTING, {
      headers: headers,
    });
}

function updateMarketingSetting(params) {
  let accessToken = localStorage.getItem('accessToken');
  let  headers= {
      'Content-Type' : 'application/json',
      'authorization': "Basic YmV1YXBwOmJldWFwcA==",
      'accessToken': `${accessToken}`
  };
  console.log("headers", params);
  return axios.put(API.UPDATE_MARKETING_SETTING, params,{headers:headers})
}

function uploadReminderImage(imageFile) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };

  const formData = new FormData();
  formData.append('image', imageFile);

  return axios.post(API.UPLOAD_REMINDER_IMAGE, formData, {
    headers: headers
  });
}

function uploadEmailBodyImage(imageFile) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };

  const formData = new FormData();
  formData.append('image', imageFile);

  return axios.post(API.UPLOAD_EMAIL_BODY_IMAGE, formData, {
    headers: headers
  });
}

function deleteEmailBodyImage(imageUrl) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`,
    'Content-Type': 'application/json'
  };

  return axios.post(API.DELETE_EMAIL_BODY_IMAGE, { imageUrl }, {
    headers: headers
  });
}

/************************************** Campaign Services ******************************************************/

function createCampaign(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.CREATE_CAMPAIGN, params, { headers: headers });
}

function updateCampaign(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.UPDATE_CAMPAIGN, params, { headers: headers });
}

function sendCampaign(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.SEND_CAMPAIGN, params, { headers: headers });
}

function getCampaigns(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.GET_CAMPAIGNS, params, { headers: headers });
}

function getCampaignDetails(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.GET_CAMPAIGN_DETAILS, params, { headers: headers });
}

function getCampaignRecipients(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.GET_CAMPAIGN_RECIPIENTS, params, { headers: headers });
}

function deleteCampaign(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.DELETE_CAMPAIGN, params, { headers: headers });
}

function estimateCost(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.ESTIMATE_CAMPAIGN_COST, params, { headers: headers });
}

function getAudienceSegments() {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.get(API.GET_AUDIENCE_SEGMENTS, { headers: headers });
}

/************************************** Analytics Services ******************************************************/

function getAnalyticsOverview(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.GET_ANALYTICS_OVERVIEW, params, { headers: headers });
}

function getAutomationStats(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.GET_AUTOMATION_STATS, params, { headers: headers });
}

function getClientCommunications(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.GET_CLIENT_COMMUNICATIONS, params, { headers: headers });
}

function getEmailTemplatePreview(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.GET_EMAIL_TEMPLATE_PREVIEW, params, { headers: headers });
}

function getInsights() {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.GET_MARKETING_INSIGHTS, {}, { headers: headers });
}

function exportAnalytics(params) {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.post(API.EXPORT_ANALYTICS, params, { headers: headers });
}

function getSalonReviews() {
  let accessToken = localStorage.getItem('accessToken');
  let headers = {
    'Content-Type': 'application/json',
    'authorization': "Basic YmV1YXBwOmJldWFwcA==",
    'accessToken': `${accessToken}`
  };
  return axios.get(API.GET_SALON_REVIEWS, { headers: headers });
}
